import React, { useState } from 'react';

import { FormBase } from '../Interface';
import EmailMessageDetail from './EmailMessageDetail';
import EmailMessageReports from './EmailMessageReports';

export const EmailMessagePage = () => {
  const [selectedValues, setSelectedValues] = useState({});
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  return (
    <FormBase
      name="EmailMessage"
      leftPanelContent={<EmailMessageDetail selectedValues={selectedValues} />}
      rightPanelContent={
        <EmailMessageReports
          values={{ selectedValues, setSelectedValues }}
          rowSelection={{ rowSelectionModel, setRowSelectionModel }}
        />
      }
    />
  );
};

export default EmailMessagePage;
